import { render, staticRenderFns } from "./X-gestion-datatable.vue?vue&type=template&id=595d5899&scoped=true"
import script from "./X-gestion-datatable.vue?vue&type=script&lang=js"
export * from "./X-gestion-datatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595d5899",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('595d5899')) {
      api.createRecord('595d5899', component.options)
    } else {
      api.reload('595d5899', component.options)
    }
    module.hot.accept("./X-gestion-datatable.vue?vue&type=template&id=595d5899&scoped=true", function () {
      api.rerender('595d5899', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/time/X-gestion-datatable.vue"
export default component.exports